import { NgModule } from "@angular/core";

import { CommonModule } from "@angular/common";
import { DirectoryRoutingModule } from "@onsip/web/features/administrators/directory/directory-routing.module";
import { DirectoriesPageComponent } from "@onsip/web/features/administrators/directory/directories-page/directories-page.component";
import { TranslateModule } from "@ngx-translate/core";
import { RouterModule } from "@angular/router";

import { ReactiveFormsModule } from "@angular/forms";
import { HeaderModule } from "@onsip/web/features/shared/components/layout/header/header.module";
import { TableDataLoadContainerModule } from "@onsip/web/features/shared/components/tableDataLoadContainer/table-data-load-container.module";
import { TableModule } from "@onsip/web/features/shared/components/table/onsip-table.module";
import { PipesModule } from "@onsip/web/features/shared/pipes/pipes.module";
import { MatSortModule } from "@angular/material/sort";
import { MatTableModule } from "@angular/material/table";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatIconModule } from "@angular/material/icon";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatDialogModule } from "@angular/material/dialog";
import { ModalModule } from "../../shared/components/modal/modal.module";
import { MatButtonModule } from "@angular/material/button";
import { DownloadDirectoryModalComponent } from "@onsip/web/features/administrators/directory/downloadDirectoryModal/download-directory-modal.component";
import { MatSelectModule } from "@angular/material/select";
import { LoadingContainerComponent } from "../../shared/components/loadingContainer/loading-container.component";

@NgModule({
  declarations: [DirectoriesPageComponent, DownloadDirectoryModalComponent],
  imports: [
    CommonModule,
    DirectoryRoutingModule,
    HeaderModule,
    TranslateModule,
    RouterModule,
    TableDataLoadContainerModule,
    ReactiveFormsModule,
    TableModule,
    PipesModule,
    RouterModule,
    MatSortModule,
    MatTableModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatDialogModule,
    ModalModule,
    MatPaginatorModule,
    MatButtonModule,
    MatSelectModule,
    LoadingContainerComponent
  ]
})
export class DirectoryModule {}
